<template>
  <div name="demo-validate-required">
    <input type="text" v-model="username"
         v-validate="'required'" 
         name="username" 
         data-vv-as="username" 
         placeholder="Username" 
         :class="{ 'input-error' : errors.has('username') }" />
    <div v-show="errors.has('username')" class="text-error">{{ errors.first('username') }}</div>
  </div>
</template>

<script>
export default {
  name: 'demo-validate-required',
  data () {
    return {
      username: ''
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoValidateRequired.vue?31bb8d3f